<div class="row align-items-end">
    <div class="col-3 col-md-2 flex-grow-0">
        <div class="mb-3">
            <label class="form-label">Puntos</label>
            <input type="number" class="form-control" [(ngModel)]="pregunta.Maximo" [disabled]="accesoPublico">
        </div>
    </div>
</div>
<h4>Items</h4>
<div class="row" *ngFor="let item of items; index as i">
    <div class="col d-flex align-items-center mb-1">
        <input type="text" class="form-control white-borders" [(ngModel)]="item.Texto" [disabled]="accesoPublico" />
    </div>
    <div class="col flex-grow-0 text-end mt-auto seleccionable" (click)="abrirEditorCondicionesItem(item)"
         *ngIf="!accesoPublico">
        <span>
            <i class="fa-regular fa-list-check fa-xl"></i>
        </span>
    </div>
    <div class="col flex-grow-0 text-end my-auto" [class.seleccionable]="borrarItemCmd.puedeEjecutarse"
         (click)="clickBorrarItem(item)" *ngIf="!accesoPublico">
        <span><i class="fa-regular fa-trash-can fa-xl"></i></span>
    </div>
</div>
<div class="row" *ngIf="!accesoPublico">
    <div class="col flex-grow-0 h3 mb-0 pe-0">+</div>
    <div class="col mb-3">
        <input type="text" placeholder="Agregue una respuesta..." class="form-control no-borders"
            [(ngModel)]="textoItem" (keyup.enter)="agregarCmd.ejecutar()" [disabled]="!agregarCmd.puedeEjecutarse" />
    </div>
</div>
